import { Alert, AlertIcon, Stack } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useTranslation } from "react-i18next";
import { BidStatus, type SourcingEventDto, useListBidsForEventQuery } from "../../../autogen/bff-api";

export const RejectedRankedEntriesNotice = ({ event }: { event: SourcingEventDto }) => {
  const { t } = useTranslation();
  const ranked = (event.eventContext.type === "Public" ? event.eventContext.designContest?.juryReport?.rankedEntries : null) ?? [];
  const { data } = useListBidsForEventQuery(ranked.length > 0 ? { eventId: event.id } : skipToken);
  const rejected = ranked
    .map((entry, index) => ({ bid: data?.bids.find((bid) => bid.id === entry.bidId), place: index + 1 }))
    .filter(({ bid }) => bid?.status === BidStatus.Rejected);
  if (rejected.length === 0) return null;
  return (
    <Stack spacing="2" mt="3">
      {rejected.map(({ bid, place }) => (
        <Alert key={bid?.id} status="warning" rounded="md" fontSize="sm">
          <AlertIcon />
          {t("{{entry}}, which the jury ranked no. {{place}}, is rejected.", { entry: bid?.ownerName, place })}
        </Alert>
      ))}
    </Stack>
  );
};
